import type { DeviceType } from '~/types/device-type'
import type { IExternalLink } from '~/types/external-links'

import config from '~/config'
import { request } from '~/utils/request'

/** @doc https://dev.app.mwm-intranet.mwmwebapis.com/#get-/app/-appKey-/device-type/-deviceType-/external-links */
export const getAppExternalLinks = ({
  appKey,
  deviceType,
}: {
  appKey: string
  deviceType: DeviceType
}): Promise<IExternalLink[]> => {
  return request<IExternalLink[]>({
    url: `${config.APP_API}/app/${appKey}/device-type/${deviceType}/external-links`,
  })
}

/** @doc https://dev.app.mwm-intranet.mwmwebapis.com/#post-/app/-appKey-/device-type/-deviceType-/external-links */
export const createAppExternalLink = (data: {
  appKey: string
  deviceType: DeviceType
  target: string
  url: string
}): Promise<void> => {
  return request({
    data: {
      target: data.target,
      url: data.url,
    },
    method: 'POST',
    url: `${config.APP_API}/app/${data.appKey}/device-type/${data.deviceType}/external-links`,
  })
}

/** @doc https://dev.app.mwm-intranet.mwmwebapis.com/#put-/app/-appKey-/device-type/-deviceType-/external-links/-externalLinkID- */
export const updateAppExternalLink = (data: {
  appKey: string
  deviceType: DeviceType
  externalLinkID: string
  target: string
  url: string
}): Promise<void> => {
  return request<void>({
    data: { target: data.target, url: data.url },
    method: 'PUT',
    url: `${config.APP_API}/app/${data.appKey}/device-type/${data.deviceType}/external-links/${data.externalLinkID}`,
  })
}

/** @doc https://dev.app.mwm-intranet.mwmwebapis.com/#delete-/app/-appKey-/device-type/-deviceType-/external-links/-externalLinkID- */
export const deleteAppExternalLink = (data: {
  appKey: string
  deviceType: DeviceType
  externalLinkID: string
}): Promise<void> => {
  return request<void>({
    method: 'DELETE',
    url: `${config.APP_API}//app/${data.appKey}/device-type/${data.deviceType}/external-links/${data.externalLinkID}`,
  })
}
